// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoryLoader_wrapper__5R96q"};